/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerSegmentsSimpleSearchQueryResponse, PntAppControllerSegmentsSimpleSearchPathParams, PntAppControllerSegmentsSimpleSearchQueryParams } from "../models/PntAppControllerSegmentsSimpleSearch";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntAppControllerSegmentsSimpleSearch } from "../axios/pntAppControllerSegmentsSimpleSearch";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntAppControllerSegmentsSimpleSearchQueryKey = (slug: PntAppControllerSegmentsSimpleSearchPathParams["slug"], params: PntAppControllerSegmentsSimpleSearchQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/simple-search', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntAppControllerSegmentsSimpleSearchQueryKey = ReturnType<typeof pntAppControllerSegmentsSimpleSearchQueryKey>

export function pntAppControllerSegmentsSimpleSearchQueryOptions(slug: PntAppControllerSegmentsSimpleSearchPathParams["slug"], params: PntAppControllerSegmentsSimpleSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntAppControllerSegmentsSimpleSearchQueryKey(slug, params)
        return queryOptions<PntAppControllerSegmentsSimpleSearchQueryResponse, ResponseErrorConfig<Error>, PntAppControllerSegmentsSimpleSearchQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntAppControllerSegmentsSimpleSearch(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Search the segments's transciptions for the given terms in the given date range using the elastic's `simple_query_string` query.
 * {@link /pnt/v2/segments/:slug/simple-search}
 */
export function usePntAppControllerSegmentsSimpleSearch<TData = PntAppControllerSegmentsSimpleSearchQueryResponse, TQueryData = PntAppControllerSegmentsSimpleSearchQueryResponse, TQueryKey extends QueryKey = PntAppControllerSegmentsSimpleSearchQueryKey>(slug: PntAppControllerSegmentsSimpleSearchPathParams["slug"], params: PntAppControllerSegmentsSimpleSearchQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntAppControllerSegmentsSimpleSearchQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntAppControllerSegmentsSimpleSearchQueryKey(slug, params)
         

         const query = useQuery({
          ...pntAppControllerSegmentsSimpleSearchQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}